import accountValues from '../clients/accounts/values'
import adminLogin from './admin-login'
import comments from './comments'
import contractHelp from './contract-help'
import testModal from './test'

export default { accountValues, adminLogin, comments, contractHelp, testModal }